import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/cp4i-demohub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ArticleDetails from '../../gatsby-theme-carbon/components/ArticleDetails';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ArticleDetails name="Ravi Katikala" lastUpdated="October 2020" readTimeMinutes="120" mdxType="ArticleDetails" />
    <p><strong parentName="p">{`APIC Dev Jam Lab Instructions`}</strong></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/APICDevJam/Lab1"
      }}>{`Lab 1 : Create and Secure an API to Proxy an Existing REST Web service`}</a></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/APICDevJam/Lab2"
      }}>{`Lab 2 : The Developer Portal Experience`}</a></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/APICDevJam/Lab3"
      }}>{`Lab 3 : Add OAuth Security to your API`}</a></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/APICDevJam/Lab4"
      }}>{`Lab 4 : Use Lifecycle Controls to Version Your API`}</a></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/APICDevJam/Lab5"
      }}>{`Lab 5: Advanced API Assembly`}</a></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/APICDevJam/Lab6"
      }}>{`Lab 6: Working with API Products`}</a></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/APICDevJam/Lab7"
      }}>{`Lab 7: The Consumer Experience`}</a></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/APICDevJam/Lab8"
      }}>{`Lab 8: Create and test GraphQL Proxy API`}</a></p>
    <p><strong parentName="p">{`APIC Dev Jam Lab Resources`}</strong></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/APICDevJam/resources/inventory.yaml"
      }}>{`inventory.yaml`}</a></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/APICDevJam/resources/logistics.yaml"
      }}>{`logistics.yaml`}</a></p>
    <p><a parentName="p" {...{
        "href": "/cp4i-demohub/APICDevJam/resources/calculate.wsdl"
      }}>{`calculate.wsdl`}</a>{`  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      